import ReportsFilters from './ReportsFilters';
import KpiCards from './KpiCards';
import ReportTable from './ReportTable';
import { formatCurrency, formatNumber } from './formatters';

const AdminClientReports = ({
  data = [],
  filters,
  onFiltersChange,
  onApply,
  onReset,
  onExport,
  loading,
  exporting,
  clients = [],
  hosts = [],
}) => {
  const totals = data.reduce(
    (acc, row) => {
      acc.spend += Number(row.totalSpend || 0);
      acc.bookings += Number(row.totalBookings || 0) + Number(row.totalTourBookings || 0);
      return acc;
    },
    { spend: 0, bookings: 0 }
  );

  return (
    <div className="space-y-4">
      <ReportsFilters
        filters={filters}
        onChange={onFiltersChange}
        onApply={onApply}
        onReset={onReset}
        onExport={onExport}
        hosts={hosts}
        clients={clients}
        showHost
        showClient
        showGroupBy={false}
        applying={loading}
        exporting={exporting}
      />

      <KpiCards
        items={[
          { label: 'Total spend', value: totals.spend, render: (v) => formatCurrency(v) },
          { label: 'Total bookings', value: totals.bookings, render: (v) => formatNumber(v) },
        ]}
      />

      <ReportTable
        loading={loading}
        columns={[
          { key: 'clientName', label: 'Client' },
          { key: 'email', label: 'Email' },
          { key: 'phone', label: 'Phone' },
          { key: 'totalBookings', label: 'Stays', render: formatNumber },
          { key: 'totalTourBookings', label: 'Tours', render: formatNumber },
          { key: 'cancelledCount', label: 'Cancelled', render: formatNumber },
          { key: 'totalSpend', label: 'Total spend', render: (v) => formatCurrency(v) },
          { key: 'lastBookingDate', label: 'Last booking' },
        ]}
        rows={data}
        emptyText="No client activity for this range."
      />
    </div>
  );
};

export default AdminClientReports;
